import { z } from '../zod.js';

export const INVOICE_STATUS = [
  'draft',
  'open',
  'paid',
  'uncollectible',
  'refunded',
  'partially_refunded',
  'void',
] as const;

export const InvoiceStatusValidationEnum = z.enum(INVOICE_STATUS);

export const INVOICE_TAX_SOURCE_VALUES = ['fixed_tax_rate', 'stripe_tax'] as const;

export const InvoiceTaxSourceValidationEnum = z.enum(INVOICE_TAX_SOURCE_VALUES);

export const INVOICE_LINE_ITEM_TYPE = [
  'product',
  'setupFee',
  'variantOption',
  'ticket',
  'ticketFee',
] as const;

export const InvoiceLineItemTypeValidationEnum = z.enum(INVOICE_LINE_ITEM_TYPE);

export const INVOICE_CHARGE_TYPE = ['payment', 'booking'] as const;

export const InvoiceChargeTypeValidationEnum = z.enum(INVOICE_CHARGE_TYPE);
